import { Platform, StyleSheet } from 'react-native';

import { FormControlTextInput } from '../form-control-text-input';
import { IconAccount } from '../icon';

import { MaskInputProps } from '.';

export const EMAIL_INPUT_ACCESSORY_ID = 'emailMaskedInput';

export function NameInput(props: MaskInputProps) {
  return (
    <FormControlTextInput
      readOnly={props.readOnly}
      style={styles.input}
      error={props.error}
      label={props.label}
      placeholder={'Enter Your Name'}
      keyboardType="default"
      leftIcon={<IconAccount size={24} />}
      onChangeText={props.onChange}
      value={props.value}
      autoFocus={props.autoFocus}
      onBlur={props.onBlur}
      onSubmitEditing={props.onSubmitEditing}
      required={props.required}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    maxHeight: 48,
    width: '100%',
    ...Platform.select({
      web: {
        flex: 1,
      },
      default: {
        flex: 0,
      },
    }),
  },
});
